import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ roles }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return <div>Loading...</div>;
  }

  // Redirect to sign-in if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" />;
  }

  // Check role-based access if roles prop is provided
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/access-denied" />;
  }

  // User is authenticated and has proper permissions
  return <Outlet />;
};

export default ProtectedRoute;
